module.exports = __webpack_public_path__ + "static/media/bit.e8b9a79d.png";